<template>
  <div class="chart-box rb shadow">
    <div class="box-header bold">
      <div>{{ chartName }}</div>
      <div v-if="index !== 4">
        <csv-download :Chart="index" :students="students" />
      </div>
      <div class="navbar-item" v-if="index == 4">
        <b-field
          class="time-filter"
          label="Period"
          label-position="on-border"
          type="is-success"
        >
          <b-select :placeholder="filterArray[2]" v-model="timeFilter">
            <option
              v-for="(option, index) in filterArray"
              :value="option"
              :key="index"
            >
              {{ option }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>
    <div>
      <slot name="chart"></slot>
    </div>
    <div class="table">
      <slot name="table"></slot>
    </div>
    <div style="text-align:center; padding-bottom: 1.5em;">
      <span
        v-if="showLink"
        class="underline bold pointer"
        style="margin-right: 2rem"
        @click="viewAll"
        >View All</span
      >
      <span
        v-if="showResultsLink"
        class="underline bold pointer"
        @click="viewDetailedResults"
        >View Detailed Results</span
      >
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import CSVDownload from "@/modules/global/components/VueXLSXDownloadComponent.vue";
export default {
  name: "chartBox",
  props: {
    chartName: { type: String },
    index: { type: Number },
    showResultsLink: { type: Boolean, default: false },
    showLink: { type: Boolean, default: true },
    students: { type: Array }
  },
  data() {
    return {
      timeFilter: "month",
      filterArray: ["day", "week", "month"]
    };
  },
  components: {
    "csv-download": CSVDownload
  },
  methods: {
    ...mapMutations({
      isModalActive: "globalStore/updateIsViewAllModalActive",
      isResultsModalActive: "globalStore/updateResultsBreackdownModalActive",
      updateTime: "globalStore/updateTime"
    }),
    viewAll() {
      this.$emit("viewAllClicked", {
        chartName: this.chartName,
        index: this.index
      });
      this.isModalActive(true);
    },
    viewDetailedResults() {
      this.isResultsModalActive(true);
    }
  },
  watch: {
    timeFilter: {
      handler: function(t) {
        this.updateTime(t);
      }
    }
  }
};
</script>
